var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Refresh_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Refresh_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Refresh_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Refresh_svg__c",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#Refresh_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.455 6.636v-2.89a.9.9 0 0 0-1.8 0v1.99h-1.91l-.077-.003a.9.9 0 0 0-.003 1.8v.003h2.89a.9.9 0 0 0 .9-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.993 12.25a5.9 5.9 0 0 0 1.262-1.873.9.9 0 1 0-1.628-.765l-.003-.001q-.325.787-.904 1.367-1.24 1.226-2.974 1.226a4.2 4.2 0 0 1 0-8.4q1.727 0 2.968 1.22l1.37 1.44 1.304-1.24-1.39-1.46-.009-.01a6.02 6.02 0 0 0-4.243-1.75 6 6 0 1 0 2.335 11.53 6 6 0 0 0 1.912-1.283"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Refresh_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgRefresh;